import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from "@angular/router";
import {
  ITagsEntity,
  TagEntityTypeEnum
} from "@pages/settings/components/manage-tags-page/manage-tags-modal/manage-tags-modal.constant";
import { ABNPipe } from '@shared/pipes/abnPipe';
import { ACNPipe } from '@shared/pipes/acnPipe';
import { getCompanyProfilePath, getTrustProfilePath } from "@shared/utils/route-path-utils";
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { EntityType } from "@models/common/entity-type.enum";
import {
  EntityNameNumberRecordComponent
} from '@shared/components/commons/entity-name-number-record/entity-name-number-record.component';

@Component({
  selector: 'app-ag-tag-entity-title',
  standalone: true,
  imports: [
    EntityNameNumberRecordComponent,
    ACNPipe,
    ABNPipe,
    RouterLink,
  ],
  templateUrl: './ag-tag-entity-title.component.html',
  styleUrl: './ag-tag-entity-title.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgTagEntityTitleComponent implements ICellRendererAngularComp {

  @Input() entityType: TagEntityTypeEnum | EntityType = TagEntityTypeEnum.Company;
  @Input() isLink = false;
  @Input() fullWidth = false;
  @Input("entity") set entitySetter(entity: ITagsEntity) {
    this.entity = entity;
    this.link = this.getLink(this.entity);
  }

  link: string | null = null;
  entity: ITagsEntity | undefined = undefined;

  readonly TagEntityTypeEnum = TagEntityTypeEnum;
  readonly entityTypeIconDictionary: Record<TagEntityTypeEnum, string> = {
    [TagEntityTypeEnum.Company]: 'icon ic-companies-20',
    [TagEntityTypeEnum.Trust]: 'icon ic-trusts-20',
    [TagEntityTypeEnum.Individual]: 'icon ic-individuals-20',
    [TagEntityTypeEnum.CoverLetter]: 'icon ic-file-20',
  };

  agInit(params: ICellRendererParams<ITagsEntity>): void {
    this.updateCell(params);
  }

  refresh(params: ICellRendererParams<ITagsEntity>): boolean {
    return this.updateCell(params);
  }

  updateCell(params: ICellRendererParams<ITagsEntity>): boolean {
    this.entity = params.data;
    this.entityType = params['entityType'] ?? TagEntityTypeEnum.Company;
    this.link = this.getLink(params.data);
    return true;
  }

  private getLink(entity?: ITagsEntity): string | null {
    if (!this.isLink) {
      return null;
    }

    switch (this.entityType) {
      case TagEntityTypeEnum.Company:
        return getCompanyProfilePath(entity?.['entityId'] ?? '').join('/');
      case TagEntityTypeEnum.Trust:
        return getTrustProfilePath(entity?.['entityId'] ?? '').join('/')
      case TagEntityTypeEnum.Individual:
        return `/individual/${ entity?.['individualId'] }`;
      default:
        return null;
    }
  }
}
